var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root"},[_c('NavBar'),_c('Masthead'),_c('Poem'),_c('introduction'),_c('Services'),_c('Portfolio'),_c('Team'),_c('Information'),_c('ContactForm'),_c('RadioFragment'),_c('Reference'),_c('SocialMedia')],1)}
var staticRenderFns = []

export { render, staticRenderFns }